
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Swiper from '~/components/swiper'
import Picture from '~/components/picture/lole-picture'
export default {
  components: { Swiper, Picture },
  computed: {
    ...mapGetters({
      vxSearchResults: 'search/getSearchResults',
      vxCarouselColorsFilter: 'search/getCarouselColorsFilter',
      vxSearchParameters: 'search/getSearchParameters',
    }),
    showColorsFilter() {
      return !!this.vxCarouselColorsFilter?.collections?.includes(
        this.vxSearchParameters?.collectionHandle
      )
    },
    allColorsFilters() {
      return (
        this.vxSearchResults?.facets?.find(
          ({ field }) => field === 'ss_normalize_color' && this.showColorsFilter
        )?.values || []
      )
    },
    colors() {
      return this.vxCarouselColorsFilter?.colors.filter((colorGroup) => {
        return colorGroup?.label?.split(',').some((color) => {
          return this.allColorsFilters.some((filter) => filter?.label === color)
        })
      })
    },
  },
  methods: {
    ...mapMutations({
      vxResetSearchResults: 'search/resetSearchResults',
      vxSetSearchFilters: 'search/setSearchFilters',
    }),
    ...mapActions({
      vxQuerySearchspring: 'search/querySearchspring',
    }),
    showColor(color) {
      const colors = color.split(',')
      const colorsFilters = []
      if (colors.length > 0) {
        colors.forEach((c) => {
          colorsFilters.push(`filter.ss_normalize_color=${c}`)
        })
      } else {
        colorsFilters.push(`filter.ss_normalize_color=${color}`)
      }
      this.vxResetSearchResults('filtering')
      this.vxSetSearchFilters(colorsFilters)
      this.vxQuerySearchspring()
    },
    isActive(color) {
      const foundString = this.vxSearchParameters?.filters
        ?.find((filter) => filter.includes('filter.ss_normalize_color'))
        ?.split('=')[1]
      return foundString === color
    },
  },
}
